import client from "./client";

const getPermissions = () => client.get("role/permissions");

export default { getPermissions };
